import { useEffect, useRef } from 'react'
import { message } from 'antd'
import CampaignService from '@forwardflow/services/CampaignService'

interface AssistantData {
   avatar: string
   assistantName: string
   voiceId: string
   description: string
   designation: string
}

interface UseCreateAssistantsProps {
   campaignTitle: string
   aiAssistants?: any[]
   defaultAssistants?: AssistantData[]
   onAssistantsCreated?: () => void
}

export const useCreateAssistants = ({
   campaignTitle,
   aiAssistants,
   defaultAssistants = [
      {
         avatar:
            'https://forward-flow-assets.s3.us-west-2.amazonaws.com/campaign-avatars/assistant-4.png',
         assistantName: 'Dakotah H',
         voiceId: 'P7x743VjyZEOihNNygQ9',
         description: 'Hello I am Dakotah H, your real state agent',
         designation: 'Sales assistant',
      },
   ],
   onAssistantsCreated,
}: UseCreateAssistantsProps) => {
   const hasCreatedAssistants = useRef(false)

   useEffect(() => {
      const createAssistants = async () => {
         if (aiAssistants?.length === 0 && !hasCreatedAssistants.current) {
            hasCreatedAssistants.current = true
            try {
               const createdAssistants =
                  await CampaignService.createOrganizationCampaignAssistantsInBulk(
                     campaignTitle,
                     defaultAssistants
                  )

               if (createdAssistants) {
                  onAssistantsCreated?.()
               }
            } catch (error) {
               console.error('Failed to create assistants:', error)
               message.error('Failed to create assistants')
               hasCreatedAssistants.current = false // Reset on error
            }
         }
      }

      if (aiAssistants !== undefined) {
         createAssistants()
      }
   }, [campaignTitle, aiAssistants, onAssistantsCreated])
}
